import { render, staticRenderFns } from "./LastButtons.vue?vue&type=template&id=90d26132&"
import script from "./LastButtons.vue?vue&type=script&lang=js&"
export * from "./LastButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports